import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

const AffiliatePasswordRecoverySuccesss = ({ changeForm }) => {
  return (
    <Fragment>
      <p className="text-center title-main-success">
        <FormattedMessage id="password.recovery.success.text" defaultMessage="Check e-mail." />
      </p>
      <div className="form-controls">
        <div className="btn btn-primary btn-big btn-block" onClick={() => changeForm('sign_in')}>
          <FormattedMessage
            id="password.recovery.success.back"
            defaultMessage="Back to home page"
          />
        </div>
      </div>
    </Fragment>
  );
};

export default AffiliatePasswordRecoverySuccesss;
